import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { PersistenceService, StorageType } from 'angular-persistence';

import { User } from '../models/';
import { ApiService } from './api.service';
import { AuthService } from './auth.service';

@Injectable()
export class MetadataService {
    private systemMetaDataCollection:any;
    private viewMetaDataCollection:any = { }

    constructor(
        private apiService: ApiService,
        private authService: AuthService,
        private storageService: PersistenceService
      ) { }
    
    loadMetadata(): Observable<any> {
        if (this.systemMetaDataCollection) {
            return new Observable(observer => {
                observer.next(this.systemMetaDataCollection);
                observer.complete();
            });        
        } else {
            return this.apiService.get("/models/metadata").map(
                (result) => {
                    this.setMetadata(result);
                    return result;
                }
            );
        }
    }

    setMetadata(result) {
        this.systemMetaDataCollection = result;
        let user:User = this.authService.getAuth();
        if (user) {
            this.storageService.set("mdc" + user.client_ID, result, {type: StorageType.SESSION});
        }
    }

    getMetadata():any {
        let user:User = this.authService.getAuth();
        this.systemMetaDataCollection = this.storageService.get("mdc" + user.client_ID, StorageType.SESSION);
        return this.systemMetaDataCollection;
    }

    getTableViewMetaData(view, params, bRefresh:boolean = false): Observable<any> {
        if (!this.viewMetaDataCollection[view] || !this.viewMetaDataCollection[view].meta_data || bRefresh) {
            return this.apiService.get("/views/" + view + "/metadata", params).map((result) => {
                this.viewMetaDataCollection[view] = { meta_data: result.meta_data };
                // object cloning to prevent referencing issues
                return JSON.parse(JSON.stringify(result));
              }
            )
        } else {
            return new Observable(observer => {
                observer.next(this.viewMetaDataCollection[view]);
                observer.complete();
            });
        }
    }
        
    ItemTypeMapping:any = {
        CU: "company",
        CO: "contact",
        LD: "lead",
        DL: "deal",
        CS: "case",
        EM: "email",
        CA: "call",
        ME: "meeting",
        TA: "task",
        FL: "file",
        PD: "product",
        PR: "product_reference",
    }

    getField(sn_ID:string):any {
        let tokens = sn_ID.split('-');        
        let fm:any = null;
        if (this.systemMetaDataCollection && tokens.length > 1) {
            let record_type = this.ItemTypeMapping[tokens[0]];
            if (record_type && this.systemMetaDataCollection[record_type]) {
                var field_mappings = this.systemMetaDataCollection[record_type].field_mappings;
                for (let i = 0; i < field_mappings.length; i++) {
                    if (field_mappings[i].system_name == tokens[1] || field_mappings[i].field_ID == tokens[1]) {
                        fm = field_mappings[i];
                        break;
                    }
                }
            }
        }
        return fm;
    }

    getFormViewMetaData(view, params, bRefresh:boolean = false): Observable<any> {
        if (!this.viewMetaDataCollection[view] || !this.viewMetaDataCollection[view].meta_data || bRefresh) {
            return this.apiService.get("/views/" + view + "/metadata", params).map((result) => {
                this.viewMetaDataCollection[view] = { meta_data: result.meta_data };
                // object cloning to prevent referencing issues
                return JSON.parse(JSON.stringify(result));
                }
            )
        } else {
            return new Observable(observer => {
                observer.next(this.viewMetaDataCollection[view]);
                observer.complete();
            });
        }
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/services/metadata.service.ts